import React from 'react'
const PageContainer:any = (props:any) => {
  return (
    <div style={{padding:20}}>
      { props.children }
    </div>
  );
}

export default PageContainer
